import React from 'react';
import styled from 'styled-components';

const EmptyTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
`;
// eslint-disable-next-line react/display-name
export default () => <EmptyTable>No results found.</EmptyTable>;
